export default __webpack_public_path__ + "static/media/Greenwich-Medium.aa2dc322.otf";